module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('el-row', {
    staticClass: "continer",
    attrs: {
      "type": "flex",
      "align": "middle",
      "gutter": 70
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 7,
      "sm": 5,
      "md": 4,
      "lg": 2
    }
  }, [_c('avatar', {
    staticClass: "imgAvatar",
    attrs: {
      "username": _vm.username
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('h2', [_vm._v(_vm._s(_vm.username) + "'s Blog")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3b05cf48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 180
// module chunks = 1